import { render } from "./EditSubServices.vue?vue&type=template&id=184a9034&scoped=true"
import script from "./EditSubServices.vue?vue&type=script&lang=js"
export * from "./EditSubServices.vue?vue&type=script&lang=js"

import "./EditSubServices.vue?vue&type=style&index=0&id=184a9034&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-184a9034"]])

export default __exports__